import Reveal from "./Reveal";
import { SectionHeading } from "./SectionHeading";

const POINTS = [
    {
        title: "Specialized",
        copy: "We specialize in U.S. elder law and estate planning firms, serving clients across the country and growing their funnels of qualified leads.",
        testid: "why-specialized",
    },
    {
        title: "Transparent",
        copy: "Clear reporting and straightforward communication.",
        testid: "why-transparent",
    },
    {
        title: "Data-driven",
        copy: "Campaign decisions are based on conversion data rather than vanity metrics.",
        testid: "why-data-driven",
    },
    {
        title: "Focused",
        copy: "One objective: build a measurable system for generating qualified opportunities.",
        testid: "why-focused",
    },
];

export const WhyScalehaus = () => (
    <section
        id="why"
        className="py-24 md:py-32 lg:py-40 bg-ink-800/40 border-y border-white/5"
    >
        <div className="shell">
            <SectionHeading
                eyebrow="Why Scalehaus"
                title="Built for firms that want marketing to make financial sense."
            />
            <div className="mt-16 md:mt-20 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
                {POINTS.map((p, i) => (
                    <Reveal key={p.title} delay={0.08 + i * 0.08} className="h-full">
                        <div
                            data-testid={p.testid}
                            className="h-full bg-ink-900 p-8 transition-colors duration-300 hover:bg-ink-hover"
                        >
                            <p className="text-xs tracking-[0.25em] text-brass-500 font-semibold">
                                0{i + 1}
                            </p>
                            <h3 className="mt-5 font-serif text-xl md:text-2xl text-white">
                                {p.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-zinc-400">
                                {p.copy}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default WhyScalehaus;
